import { z } from "zod";

export const DailySchema = z.object({
    filter: z.object({
        property_id: z.string().uuid(),
        base_on: z.enum(["stay_date", "created_reservation"]), // Must be one of these values
        start_date: z.string().regex(/^\d{4}-\d{2}-\d{2}$/, {
            message: "start_date must be in format YYYY-MM-DD",
        }),
        end_date: z.string().regex(/^\d{4}-\d{2}-\d{2}$/, {
            message: "end_date must be in format YYYY-MM-DD",
        }),
        room_type_id: z
            .string()
            .optional()
            .refine((val) => !val || val.split(",").every((id) => id.length > 0), {
                message: "room_type_id must be a comma-separated list of valid IDs",
            }),
    }),
});

export type DailySchemaType = z.infer<typeof DailySchema>;